import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { generateControlId } from '@shared/form-elements/form-helpers/generate-control-id';

@Pipe({
    name: 'controlToKeyName',
    standalone: true
})
export class ControlToKeyNamePipe implements PipeTransform {
    transform(control: AbstractControl): string {
        const formGroup = control.parent as UntypedFormGroup;
        if (control.parent) {
            const keyName = Object.keys(control.parent.controls).find(
                inputKey => formGroup.controls[inputKey] === control
            );
            return keyName ?? '';
        }

        return `form-control-${generateControlId(control).next().value}`;
    }
}
